import { useEffect, useState } from 'react';

import DropdownSelector from './dropdown-selector';
import Conditions from '../../constants/conditions';
import SelectionItem from '../../types/selection-item';

export interface ConditionSelectorProps {
  condition?: string;
  selectedIdentifier?: string;
  onChange: (condition: string) => void;
}

export const ConditionSelector = ({
  condition,
  selectedIdentifier,
  onChange
}: ConditionSelectorProps) => {
  const [className, setClassName] = useState<string>('');
  const [conditionList, setConditionList] =
    useState<SelectionItem[]>(Conditions);

  const handleConditionChangeChange = (condition: string) => {
    if (onChange) onChange(condition);
  };

  useEffect(() => {
    setClassName(`condition--${condition ?? 'select'}`);
  }, [condition]);

  useEffect(() => {
    let filteredIdentifiers = Conditions.filter((item) =>
      selectedIdentifier
        ? item.availableOnIdentifiers?.includes(selectedIdentifier)
        : !item.availableOnIdentifiers
    );

    if (selectedIdentifier && !filteredIdentifiers.length) {
      filteredIdentifiers = Conditions.filter(
        (item) => !item.availableOnIdentifiers
      );
    }

    setConditionList(filteredIdentifiers);
  }, [selectedIdentifier]);

  return (
    <div className={'d-flex flex-column me-2'}>
      <span>
        {selectedIdentifier === 'score' ? "Is or isn't" : "Does or doesn't"}
      </span>
      <DropdownSelector<SelectionItem, 'name'>
        fieldName="name"
        placeholder={
          selectedIdentifier === 'score' ? "is or isn't" : "does or doesn't"
        }
        items={conditionList}
        additionalClassname={className}
        onClick={(e) => handleConditionChangeChange(e.name)}
        selected={Conditions?.find((x) => x.name === condition)?.description}
      />
    </div>
  );
};
